import axios from 'axios';
import store from '@speechki-frontend/core/store/store';

// @TODO might not need that, maybe to take locale from localstorage so it doesn't take dependency
import i18n from '@speechki-frontend/core/i18n/i18n';
import { setHttp } from '@speechki-frontend/shared/axios/httpRef';

import { makeid } from '@speechki-frontend/shared/helpers/functions';

import { refreshGuestAccessToken } from '@speechki-frontend/core/auth/services/resfresh';
import { getGuestAccessToken } from '@speechki-frontend/core/auth/utils';
import { checkEditorAvailability } from '@speechki-frontend/core/auth/services/availability';

const baseURL = process.env.VUE_APP_BASE_URL;

const _axios = axios.create({
    baseURL,
});

const LOCALES_MAP = {
    rus: 'ru',
    eng: 'en',
};

function isGuestAcccess() {
    return !!sessionStorage.getItem('guest_access');
}

_axios.defaults.headers.common['Accept-Language'] = LOCALES_MAP[i18n.global.locale];

_axios.interceptors.request.use(
    function (config) {
        if (isGuestAcccess()) {
            config.headers['Authorization'] = 'Guest ' + getGuestAccessToken();
            return config;
        }

        const token = localStorage.getItem('token');

        if (token) {
            config.headers['Authorization'] = 'JWT ' + token;
        }

        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

_axios.interceptors.response.use(
    function (response) {
        console.log(response.config.url, response.data);
        return response.data;
    },
    function (error) {
        if (error.response) {
            if (error.response.status === 401 || error.response.status === 403) {
                const isGuestAccess = sessionStorage.getItem('guest_access');

                if (isGuestAccess) {
                    const originalRequest = error.config;

                    if (originalRequest.isGuestAccessRetry) {
                        sessionStorage.clear();
                        store.commit('CLEAR_USER_DATA');
                        return;
                    }

                    originalRequest.isGuestAccessRetry = true;

                    return refreshGuestAccessToken()
                        .then((response) => {
                            sessionStorage.setItem('token', response.data.token);
                            sessionStorage.setItem('refresh_token', response.data.refresh_token);
                            sessionStorage.setItem('guest_access', true);
                            originalRequest.headers.Authorization = 'Guest ' + response.data.token;
                            return store.dispatch('guestAccess/createGuestAccessState', {
                                token: response.data.token,
                                refreshToken: response.data.refresh_token,
                            });
                        })
                        .then(() => {
                            return checkEditorAvailability();
                        })
                        .then((response) => {
                            if (!response.is_available) throw new Error('Editor unavailable');
                            return Promise.resolve();
                        })
                        .then(() => {
                            return _axios(originalRequest);
                        })
                        .catch(() => {
                            sessionStorage.clear();
                            store.commit('CLEAR_USER_DATA');
                            store.commit('REFRESH_TOKEN_ERROR');
                        });
                }

                store.commit('CLEAR_USER_DATA');
                return Promise.reject({ ...error.response.data, status: error.response.status });
            }

            if (error.response.status >= 500) {
                store.dispatch('pushToast', {
                    id: makeid(),
                    type: 'error',
                    title: `${error.response.status} ${error.response.statusText}`,
                    text: 'Please try again later',
                });
                return;
            }
            if (error.response.data) {
                return Promise.reject({ ...error.response.data, status: error.response.status });
            }
            return Promise.reject(error.response);
        } else {
            window.location.href = '/unavailable';
        }
    }
);

const Plugin = {
    install(app) {
        app.config.globalProperties.$http = _axios;
        setHttp(_axios);
    },
};

export default Plugin;
